import { ColoredTextItem, NamedColorList } from 'src/app/domainObjects/coloredTextItem';
import { EventNamerTransformRule } from 'src/app/domainObjects/transformers/eventNamerTransform';
import { TransformRuleViewModel } from 'src/app/viewModels/transformRuleViewModel';
import { PriorityStringType } from 'src/app/views/dataTransformConfig/transformers/base/base-transformer-ui/base-transformer-ui.component';

export class EventNamerRuleViewModel extends TransformRuleViewModel {
    sourceColumn: string;
    targetColumn: string;
    actionString?: ColoredTextItem[];
    objectString?: ColoredTextItem[];
    priorityString: PriorityStringType;
    includeAction: boolean;
    ignoreSpaces: boolean;
    matchCase: boolean;
    
    hits?: number;
    sampleHits?: number;
    
    
    constructor(rule: EventNamerTransformRule) {
      super(rule.ruleId, rule.index, rule.run, rule.ruleName);

      this.sourceColumn = rule.sourceField;
      this.targetColumn = rule.targetField;
      this.name = rule.name;
      this.includeAction = rule.includeAction;
      this.ignoreSpaces = rule.ignoreSpaces;
      this.matchCase = rule.matchCase;
      this.run = rule.run;
      this.priorityString = rule.priorityString;
      const maxIndex = NamedColorList.length - 1;

      let colorIndex = 0;
      this.actionString = rule.actionString?.map(r => {
        if (colorIndex > maxIndex) {
          colorIndex = 0;
        }
        return new ColoredTextItem(r, NamedColorList[colorIndex++]);
      });

      colorIndex = 0;
      this.objectString = rule.objectString?.map(r => {
        if (colorIndex > maxIndex) {
          colorIndex = 0;
        }
        return new ColoredTextItem(r, NamedColorList[colorIndex++]);
      });
    }
  
    toEventNamerRule(): EventNamerTransformRule {
      const rule = new EventNamerTransformRule();
      rule.index = this.index - 1;
      rule.ruleName = this.ruleName;
      rule.sourceField = this.sourceColumn;
      rule.targetField = this.targetColumn;
      rule.actionString = this.actionString?.map(a => a.text);
      rule.objectString = this.objectString?.map(a => a.text);
      rule.priorityString = this.priorityString;
      rule.includeAction = this.includeAction;
      rule.ignoreSpaces = this.ignoreSpaces;
      rule.matchCase = this.matchCase;
      rule.run = this.run;
      
      return rule;
    }
  }